<template functional>
  <div class="footer">
    <div class="footer-content-column">
      <img src="../assets/image/logo1.png" width="100px" />
      <!-- <logo :is-transparent="true"></logo> -->

      <!-- <p class="title">京公网安备 11000002002023号 I 京ICP备12025439号-3</p> -->
    </div>
    <div class="footer-content-column">
      <div class="title">联系我们</div>
      <p>联系方式:15757183400</p>
      <p>公司地址:下沙街道长空路1号</p>

      卓睿app:<el-link
        target="_blank"
        href="http://60.191.37.82:18193/zhuoRui.apk"
        >下载链接</el-link
      >
    </div>
    <div class="footer-content-column">
      <div class="title">企业官网</div>
      <p>卓睿供应链有限公司</p>
      <el-link
        target="_blank"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        >浙公网安备33019202000606号</el-link
      >
    </div>
    <div class="footer-content-column">
      <div class="title">实时动态与合作信息，请关注我们</div>
      <ul class="footer-content-column__contact">
        <el-popover
          placement="top-start"
          title="关注微信公众号"
          width="100"
          trigger="hover"
        >
          <div>
            <img
              style="width: 95%;height: 100%;"
              src="../assets/image/weixin.jpg"
            />
          </div>
          <span slot="reference">
            <li class="contact-item wechat">
              <svg width="33" height="32">
                <defs>
                  <path id="icon-wechat_svg__a" d="M0 0h1440v251H0z" />
                </defs>
                <g fill="none" fill-rule="evenodd">
                  <path fill="#FFF" d="M-1120-7901H320V126h-1440z" />
                  <use
                    fill="#1F2329"
                    fill-rule="nonzero"
                    transform="translate(-1120 -125)"
                    xlink:href="#icon-wechat_svg__a"
                  />
                  <g transform="translate(.5)">
                    <rect width="32" height="32" fill="#2EA121" rx="16" />
                    <path
                      fill="#FFF"
                      d="M21.714 17.68a.798.798 0 0 0 .786-.808.798.798 0 0 0-.786-.809.798.798 0 0 0-.787.809c0 .446.352.809.787.809zm-3.84 0a.798.798 0 0 0 .786-.808.798.798 0 0 0-.786-.809.798.798 0 0 0-.787.809c0 .446.352.809.787.809zm-2.198-4.685a.939.939 0 0 0 .925-.952.939.939 0 0 0-.925-.95.939.939 0 0 0-.925.95c0 .526.414.952.925.952zm-4.65 0a.939.939 0 0 0 .926-.952.939.939 0 0 0-.925-.95.939.939 0 0 0-.926.95c0 .526.414.952.926.952zm11.078 10.184a.4.4 0 0 0-.325-.038 6.65 6.65 0 0 1-1.974.296c-3.2 0-5.794-2.226-5.794-4.972 0-2.745 2.594-4.97 5.794-4.97 3.2 0 5.795 2.225 5.795 4.97 0 1.517-.792 2.875-2.04 3.787a.308.308 0 0 0-.114.324l.273 1.07c.082.32-.08.447-.358.28l-1.257-.747zm-11.088-3.61a8.012 8.012 0 0 0 2.721.339 4.676 4.676 0 0 1-.235-1.466c0-2.995 2.853-5.423 6.373-5.423.123 0 .245.003.366.008C19.72 10.18 16.838 8 13.363 8 9.517 8 6.4 10.668 6.4 13.958c0 1.81.942 3.43 2.43 4.522a.43.43 0 0 1 .159.455l-.327 1.256c-.1.379.09.527.42.329l1.49-.895a.549.549 0 0 1 .444-.056z"
                    />
                  </g>
                </g>
              </svg>
            </li>
          </span>
        </el-popover>
        <el-popover
          placement="top-start"
          title="关注抖音账号"
          width="100"
          trigger="hover"
        >
          <div>
            <img
              style="width: 95%;height: 100%;"
              src="../assets/image/douyin.png"
            />
          </div>
          <span slot="reference">
            <li class="contact-item douyin">
              <svg width="33" height="34">
                <defs>
                  <path id="icon-douyin_svg__a" d="M0 0h1440v251H0z" />
                  <filter
                    id="icon-douyin_svg__b"
                    width="537.5%"
                    height="520%"
                    x="-218.8%"
                    y="-210%"
                    filterUnits="objectBoundingBox"
                  >
                    <feOffset
                      dy="2"
                      in="SourceAlpha"
                      result="shadowOffsetOuter1"
                    />
                    <feGaussianBlur
                      in="shadowOffsetOuter1"
                      result="shadowBlurOuter1"
                      stdDeviation="12.5"
                    />
                    <feColorMatrix
                      in="shadowBlurOuter1"
                      result="shadowMatrixOuter1"
                      values="0 0 0 0 0.121568627 0 0 0 0 0.137254902 0 0 0 0 0.160784314 0 0 0 0.1 0"
                    />
                    <feMerge>
                      <feMergeNode in="shadowMatrixOuter1" />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>
                <g fill="none" fill-rule="evenodd">
                  <path fill="#FFF" d="M-1175-7900H265V127h-1440z" />
                  <use
                    fill="#1F2329"
                    fill-rule="nonzero"
                    transform="translate(-1175 -124)"
                    xlink:href="#icon-douyin_svg__a"
                  />
                  <g transform="translate(.5 1)">
                    <circle cx="16" cy="16" r="16" fill="#000" stroke="#000" />
                    <g
                      filter="url(#icon-douyin_svg__b)"
                      transform="translate(4 4)"
                    >
                      <path
                        fill="#00F7EF"
                        d="M10.385 10.126v-.773a6.04 6.04 0 0 0-.813-.059c-3.326 0-6.031 2.697-6.031 6.01a6 6 0 0 0 2.575 4.922 5.976 5.976 0 0 1-1.62-4.093c0-3.266 2.629-5.93 5.89-6.007"
                      />
                      <path
                        fill="#00F7EF"
                        d="M10.528 18.878a2.751 2.751 0 0 0 2.749-2.641l.005-13.087h2.4a4.532 4.532 0 0 1-.078-.83h-3.277l-.005 13.088a2.751 2.751 0 0 1-4.028 2.326 2.753 2.753 0 0 0 2.234 1.144m9.635-11.287v-.727a4.542 4.542 0 0 1-2.483-.736 4.565 4.565 0 0 0 2.483 1.463"
                      />
                      <path
                        fill="#FF004F"
                        d="M17.68 6.128a4.513 4.513 0 0 1-1.12-2.978h-.879a4.551 4.551 0 0 0 2 2.978M9.572 12.56a2.753 2.753 0 0 0-2.754 2.745c0 1.054.6 1.97 1.477 2.43a2.72 2.72 0 0 1-.522-1.602 2.753 2.753 0 0 1 2.755-2.745c.283 0 .555.047.812.127v-3.334a6.04 6.04 0 0 0-.812-.058c-.048 0-.095.002-.143.003v2.56a2.721 2.721 0 0 0-.813-.126"
                      />
                      <path
                        fill="#FF004F"
                        d="M20.163 7.591v2.538a7.813 7.813 0 0 1-4.559-1.46v6.636c0 3.314-2.706 6.01-6.032 6.01a6.01 6.01 0 0 1-3.456-1.089 6.025 6.025 0 0 0 4.411 1.918c3.326 0 6.032-2.696 6.032-6.01V9.496a7.812 7.812 0 0 0 4.56 1.461V7.693c-.328 0-.647-.036-.956-.102"
                      />
                      <path
                        fill="#FFF"
                        d="M15.604 15.305V8.669a7.813 7.813 0 0 0 4.56 1.46V7.591a4.565 4.565 0 0 1-2.484-1.463 4.552 4.552 0 0 1-1.999-2.978h-2.399l-.005 13.087a2.752 2.752 0 0 1-4.983 1.497 2.745 2.745 0 0 1-1.476-2.43 2.753 2.753 0 0 1 2.754-2.744c.284 0 .556.046.813.127v-2.56c-3.26.075-5.89 2.74-5.89 6.006 0 1.58.617 3.019 1.62 4.093a6.01 6.01 0 0 0 3.457 1.09c3.326 0 6.032-2.697 6.032-6.011"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </li>
          </span>
        </el-popover>
      </ul>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.footer {
  height: 220px;
  min-width: @main-width;
  background: rgba(0, 0, 0, 1);
  color: #fff;
  display: flex;
  font-size: @font-size-small;
  padding: 0 150px;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  &-content-column {
    padding: 0 40px;
    height: 100px;
    .title {
      color: @secondary-text-color;
    }
    &:last-child {
      width: 340px;
      padding: 0 80px;
    }
    & + & {
      text-align: center;
      flex: 1;
      border-left: 1px solid @border-dark-color;
    }

    &__contact {
      margin-top: 20px;
      display: flex;
      justify-content: space-evenly;
      .contact-item {
        border-radius: 50%;
        width: 33px;
        height: 33px;
        overflow: hidden;
      }
    }
  }
}
</style>
